module.exports = __webpack_public_path__ + "zw.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/zw.svg
// module id = 899
// module chunks = 0